
import router from '@/router'
import { defineComponent, ref } from 'vue'
import Title from './title.vue'
import SearchBar from './searchBar.vue'

export default defineComponent({
  components: {
    Title,
    SearchBar,
  },

  setup() {
    const searchTxt = ref<string>('')
    const searchConcept = () => {
      router.push('./topicList')
    }
    const handleKeydown = (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        searchConcept()
      }
    }

    return {
      searchTxt,
      searchConcept,
      handleKeydown,
    }
  },
})
